<template>
  <div>
    <el-form ref="form" :model="form" :rules="rules" label-width="250px">

    <!-- 第二步 -->
    <div>
        <el-form-item class="personList" label="著作权人" prop="right">
        <span v-for="(author, index) in form.right" :key="index">
          <span>{{ author.obligeeType == "1" ? author.userName : author.companyName }}&nbsp;</span>
        </span>
        <el-button type="text" @click="isRightDialogVisible = true"
            >选择著作权人</el-button
        >
        <choose-person-dialog
            title="选择著作权人"
            v-if="isRightDialogVisible"
            v-model="form.right"
            :listOpt="obligees"
            :linkObj="{ label: '添加著作权人', path: '/Mine/Obligee' }"
            @close="onSetRightDialogClose"
            @input="onChooseRight"
        ></choose-person-dialog>
        </el-form-item>
        <el-form-item class="submitRow">
        <el-button type="primary" @click="prev">上一步</el-button>
        <el-button type="primary" @click="next">下一步</el-button>
        </el-form-item>
    </div>
    </el-form>
  </div>
</template>

<script>
import multipleSelect from "../../../../components/form/multipleSelect";
import choosePersonDialog from "../../../../components/form/choosePersonDialog";
import { queryObligeeList } from "@/api/ObligeeService";
import resultView from "../components/resultView";
import ChinaAreaData from "@/components/ChinaAreaData";
import { mapGetters } from "vuex";
import { mixinsScrollErrorPosition } from "../../../../mixins";
import constants from "@/utils/constants";

export default {
  name: "RegisterInputForm",
  mixins: [mixinsScrollErrorPosition],
  components: {
    multipleSelect,
    choosePersonDialog,
    resultView,
    ChinaAreaData,
  },
  props: {
    stepForm: Object,
  },
  data() {
    return {
      constants,
      // form: {
      //   right: [],
      // },
      form: this.stepForm,
      rules: {
        right: [
          { required: true, message: "请选择著作权人", trigger: "blur" },
        ],
      },
      isAuthorDialogVisible: false,
      isRightDialogVisible: false,
    };
  },
  computed: {
    ...mapGetters(["mid", "userInfo", "evidencePaymentPrice", "vipInfo","obligeeList"]),
  },
  created() {
    // 从 localStorage 中加载数据
    const savedData = localStorage.getItem(`form01_${this.mid}`);
    if (savedData) {
      this.form = JSON.parse(savedData);
    }
    
    this.loadData();
    // this.form = this.stepForm
  },
  watch: {
    form: {
      handler(newValue) {
        // 自动保存表单数据到 localStorage
        localStorage.setItem(`form01_${this.mid}`, JSON.stringify(newValue));
      },
      deep: true
    }
  },
  methods: {
    loadData() {
    //   queryExistOrderItems().then(({ data }) => {
    //     this.fileList = data;
    //   });
      if (this.mid) {
        // 打开页面更新一下著作权人
        // queryObligeeList(1, 50).then(({ data }) => {
        //   // console.log('zhuzuoquanren:',data.list);
        //   if (data && data.list.length > 0) {
        //     this.$store.commit("setObligeeList", data.list); // 默认倒序
        //   }
        // });
        this.getAllObligeeData().then(allData => {
          if (allData && allData.length > 0) {
            this.$store.commit("setObligeeList", allData);
          }
        });
      }
      if(this.obligeeList){
        this.obligees = this.obligeeList;
      }else{
        this.$message.error("获取著作权人列表失败")
        // 如果数据还未加载完成，可以设置监听或延迟检查
        const timer = setInterval(() => {
            if (this.obligeeList) {
                this.obligees = this.obligeeList;
                clearInterval(timer);
            }
        }, 100);
      }
    },
// 循环版本
async getAllObligeeData() {
  const pageSize = 50;
  let page = 1;
  let allData = [];
  
  try {
    // 先获取第一页数据，知道总数
    const firstResponse = await queryObligeeList(page, pageSize);
    
    if (!firstResponse.data || !firstResponse.data.list) {
      return [];
    }
    
    allData = allData.concat(firstResponse.data.list);
    
    // 计算总页数
    const total = firstResponse.data.total;
    const totalPages = Math.ceil(total / pageSize);
    
    // 如果有多页数据，并行请求剩余页（可选，也可以串行）
    if (totalPages > 1) {
      const pagePromises = [];
      
      for (let i = 2; i <= totalPages; i++) {
        pagePromises.push(queryObligeeList(i, pageSize));
      }
      
      // 等待所有请求完成
      const responses = await Promise.all(pagePromises);
      
      responses.forEach(response => {
        if (response.data && response.data.list) {
          allData = allData.concat(response.data.list);
        }
      });
    }
    
    return allData;
  } catch (error) {
    console.error('获取著作权人数据失败:', error);
    return allData; // 返回已获取的数据
  }
},

    async onSubmit() {
      console.log("onSubmit..");
      try {
        const formBaseResult = await this.$refs["form"].validate();
      } catch (error) {
        // 有错误,定位到错误
        // eslint-disable-next-line
        console.error(error);
        this.mixinsScrollView();
        return;
      }
      this.setTabIdx("tab2");
    },
    setTabIdx(tabIdx) {
      this.tabIdx = tabIdx;
    },
    onSetAuthorDialogClose() {
      this.isAuthorDialogVisible = false;
    },
    onSetRightDialogClose() {
      this.isRightDialogVisible = false;
    },
    onChooseAuthor(users) {
      this.form.author = users;
    },
    onChooseRight(users) {
      this.form.right = users;
      this.$refs.form.validateField('right');
    },
    valiCity(rule, value, callback) {
      if (!this.form.province) {
        callback(new Error("请选择省份"));
        return;
      }
      if (!this.form.city) {
        callback(new Error("请选择城市"));
        return;
      }
      if (!this.form.area) {
        callback(new Error("请选择区县"));
        return;
      }
      callback();
    },

    chooseSignatureType() {},

        prev(){
            this.$emit('getnext',1)
        },
        async next(){
            try {
              const formBaseResult = await this.$refs["form"].validate();
            } catch (error) {
              // 有错误,定位到错误
              // eslint-disable-next-line
              console.error(error);
              this.mixinsScrollView();
              return;
            }
            this.$emit('getnext',3,this.form)
        },

  },
};
</script>

<style lang='scss' scoped>
@import "../../../../assets/css/inputForm.scss";
.commonWhiteBg {
  min-height: 800px;
  /deep/ .ant-popover-arrow {
    left: 30%;
  }
}
.ownershipRow {
  margin-bottom: 0;
}
.ownershipWrap {
  position: relative;
  padding-top: 40px;
  /deep/ .el-radio-group {
    position: absolute;
    width: 200%;
    left: 0;
    top: 11px;
  }
  .tips {
    margin-top: 0;
    .red {
      color: #ff4d4f;
      vertical-align: middle;
    }
  }
}
// .tips {
//   margin-top: 20px;
// }
.tips {
  // position: initial;
  position: absolute;
    width: 384px;
    right: -410px;
    top: 0;
}
.signatureName {
  .el-select,
  .el-input {
    width: calc(110% / 2.4);
  }
  .el-select {
    margin-right: calc(20% / 2.4);
  }
}
.Uploader2 {
  font-size: 14px;
  height: 100%;
  text-align: center;
  background: #f9fafc;
  border-radius: 4px;
  border: 1px solid #c0ccda;
}
/deep/ .submitRow .el-form-item__content {
  display: -webkit-flex;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.MainStepsForm .submitRow button {
  width: 46% !important;
}

.stepTitle{
  width: 100%;
  margin: 50px 0 100px 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.stepTitle li {
  padding: 0 10px;
}
.stepTitle li span{
  display: inline-block;
  width: 40px;
  height: 40px;
  line-height: 40px;
  border-radius: 50%;
  text-align: center;
  border: 1px solid rgba(0, 18, 22, 0.2);
  font-size: 16px;
  color: rgba(0, 18, 22, 0.2);

}
.stepTitle li p{
  color: rgba(0, 18, 22, 0.45);
  display: inline-block;
  margin-left: 10px;
  font-size: 16px;
}
.stepTitle li.active span{
  border-color: #007DFF;
  color: #fff;
  background: #007DFF;
}
.stepTitle li.active p{
  color: #007DFF;
}

// 适配移动端
@media screen and (max-width: 991px){
  /deep/ .el-form-item__content{margin-left: 0!important;display: inline-block;width: 100%;}
  /deep/ .el-form-item__label{width: auto!important;}
}

</style>
